import React from "react";
import styles from "./lessonNumberNav.module.css";
import { motion } from "framer-motion";
import { Link } from "@reach/router";

export default function LessonNumberNav({ lessons, currLesson }) {
  return (
    <div className={styles.lessonNumberNav}>
      {lessons.map((l) => {
        const numberText = l.number > 0 ? l.number : "i";
        const isSelected = l === currLesson;

        return (
          <div key={l.id} className={styles.navHolder}>
            <motion.div
              className={styles.lessonIcon}
              whileHover={{
                scale: 1.5,
              }}
              whileTap={{ scale: 0.9 }}
            >
              <Link to={`/${l.id}`}>{numberText}</Link>
            </motion.div>

            {isSelected && (
              <motion.div
                className={styles.navIndicator}
                style={{
                  background: l.colour,
                }}
                layoutId="navIsSelected"
              >
                {numberText}
              </motion.div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// const LessonButt = ({ lesson, isSelected, onClick }) => {
//   return (
//     <div
//       className={styles.navButtHolder}
//     >
//       <NavButt lesson={lesson} isSelected={isSelected} />
//       {isSelected && (
//         <motion.div
//           className={styles.selectedNavButt}
//           style={{ background: lesson.colour, color: "white" }}
//           layoutId="navIsSelected2"
//         />
//       )}
//     </div>
//   );
// };
